import { Form, Input, InputNumber, Select, Switch } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";

type Props = {};

const LevelAttributesForm = (props: Props) => {
  const { t } = useTranslation();
  return (
    <div>
      <Form.Item
        name={"name"}
        label={t("form:name")}
        rules={[{ required: true, message: t("error:name_is_required") }]}
      >
        <Input />
      </Form.Item>
      {/* <Form.Item
        name={"sortOrder"}
        label={t("form:orderNumber")}
        rules={[
          { required: true, message: t("error:order_number_is_required") },
        ]}
      >
        <InputNumber controls={false} changeOnWheel={false} />
      </Form.Item> */}
      <Form.Item
        name={"isMandatory"}
        label={t("form:mandatory")}
        rules={[{ required: false, message: t("error:mandatory_is_required") }]}
      >
        <Switch />
      </Form.Item>
      <Form.Item
        name={"optionList"}
        label={t("form:options")}
        rules={[{ required: true, message: t("error:options_is_required") }]}
      >
        <Select
          mode="tags"
          style={{ width: "100%" }}
          defaultOpen={false}
          open={false}
          suffixIcon={null}
        />
      </Form.Item>
    </div>
  );
};

export default LevelAttributesForm;
